module.exports = __webpack_public_path__ + "img/bell.4590f666.svg";